import * as React from 'react';

type Props = {
  ref: React.MutableRefObject<HTMLElement | null>;
  // update interval in ms
  updateInterval?: number;
}

export const useOffsetTop = ({ ref, updateInterval }: Props) => {
  const [offsetTop, setOffsetTop] = React.useState(0);

  React.useEffect(() => {
    const updateOffsetTop = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        setOffsetTop(rect.top + window.scrollY);
      }
    };

    // run at least once
    updateOffsetTop();

    const resizeObserver = new ResizeObserver(() => {
      updateOffsetTop();
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    resizeObserver.observe(document.body);

    let interval: NodeJS.Timer | null = null;

    if (updateInterval) {
      interval = setInterval(updateOffsetTop, updateInterval);
    }

    window.addEventListener('resize', updateOffsetTop);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateOffsetTop);
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [ref, updateInterval]);

  return offsetTop;
};
